<template>
  <div class="vehicle-renewal-info-main">
    <div class="box">
      <div class="flex-row">
        <button @click="inspectionClicked" style="width: 100px; height: 100%;" :disabled="viewMode"> {{data.inspectionSearch}} </button>
        <Input placeholder="" :inputValue.sync="data.inspectionno" :isDisabled="viewMode" style="padding: 10px;"/> 
      </div>  

      <DateTimePicker title="Effective Date" :showTime="false" style="justify-content: flex-start; padding-left: 5px;" :value.sync="data.effectivedate" :isDisabled="viewMode" />
      <DateTimePicker title="Expiry Date" :showTime="false" style="justify-content: flex-start; padding-left: 5px;" :value.sync="data.expirydate" :isDisabled="viewMode" />

      <div class="flex-row">
        <Input placeholder="Duration" :inputValue.sync="data.duration" :isDisabled="viewMode" style="padding-right: 10px;"/> 
        <Input placeholder="Amount(RM)" :inputValue.sync="data.amount_rm" :isDisabled="viewMode" /> 
      </div> 

      <RemarksBox title="Remarks" maxLength="200" :text.sync="data.remark" :isDisabled="viewMode"/>
    </div>

    <Tabulator class="renewalinfo-tabulator" style="height: unset" :tableData="data.renewalInfoData" :multiSelect="1" :selectedRow.sync="selectedPolicy"/>

    <ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition" :contextItems="contextItems"
      @contextSelected="contextSelected" ref="context" style="background-color: lightgrey; color: black;"/>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import Dropdown from '@/components/Dropdown.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Tabulator from '@/components/Tabulator.vue';
import RemarksBox from '@/components/RemarksBox.vue';
import ContextMenu from '@/components/ContextMenu.vue';

export default {
  components: {
    Input, Dropdown, DateTimePicker, Tabulator, RemarksBox, ContextMenu
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    viewMode: { type: Boolean, default: false },

    renewalInfoButton: { type: String, default: 'Button' },

    showContextMenu: { type: Boolean, default: false },
    contextItems: { type: Array, default: function() { return [ 'Road Tax', 'Insurance','Permit', 'Plant & Machinery', 'Custom Bonded', 'Special Inspection', 'Usahawan', ] } },
    contextPosition: { type: Array, default: function() { return [ 100, 15 ] } },

    selectedPolicy: { type: Array, default: function() { return [] } },
  },
  methods: {
    contextSelected: function(item) {
      this.data.inspectionSearch = item ? item.trim() : 'Button';
    },
    inspectionClicked: function() {
      this.showContextMenu = true;
    },
  },
  mounted() {
    this.data.inspectionSearch = this.data.inspectionSearch ? this.data.inspectionSearch.trim() : 'Button';
  },
  watch: {
    selectedPolicy: function() {
      if(this.selectedPolicy.length >= 1){
        this.data.inspectionSearch = this.selectedPolicy[0].PolicyName ? this.selectedPolicy[0].PolicyName.trim() : '';
        this.data.inspectionno = this.selectedPolicy[0].PolicyNo ? this.selectedPolicy[0].PolicyNo : '';
        this.data.effectivedate = new Date(this.selectedPolicy[0]['EffectiveDate']);
        this.data.expirydate = new Date(this.selectedPolicy[0]['ExpireDate']);
        this.data.duration = this.selectedPolicy[0].Duration ? this.selectedPolicy[0].Duration.trim() : null;
        this.data.amount_rm = this.selectedPolicy[0].Amount ? this.selectedPolicy[0].Amount.trim() : '';
        this.data.remark = this.selectedPolicy[0].Remark ? this.selectedPolicy[0].Remark.trim() : '';
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.flex-row {
  display: flex;
}

.box{
  border: 1px solid darkgrey;
  padding: 15px;
  margin: 15px;
}

.renewalinfo-tabulator {
  height: calc(100% - 95px) !important;
}
</style>